<template>
  <div>
    <v-snackbar
      v-if="notification && notification.id"
      v-model="showNotification"
      right
      :color="notification.type"
      :timeout="-1"
    >
      {{ notification.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const timeout = 4000
export default {
  name: 'NotificationSnack',
  data() {
    return {
      notification: null,
      timeout,
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notification/notifications',
    }),
    showNotification() {
      return this.notification && this.notification.id
    },
  },
  watch: {
    notifications(value) {
      if (value && value.length > 0) {
        const notification = Object.assign({}, value[value.length - 1], {
          timeout: this.timeout,
        })
        this.notification = notification
        setTimeout(() => this.remove(notification.id), this.timeout)
      } else {
        this.notification = null
      }
    },
  },
  methods: {
    ...mapActions({
      remove: 'notification/remove',
    }),
  },
}
</script>
